/**
 * Overflow affordance for the filter rail.
 *
 * The rail scrolls horizontally with its scrollbar hidden, so on anything
 * narrower than roughly 1700px the last Colour-by chips are simply cut off by
 * the viewport edge with nothing to suggest they exist. A soft fade on whichever
 * side still has content says "there is more here" without adding chrome, and it
 * disappears entirely once everything fits.
 */
const rail = document.getElementById('rail');

function update() {
  if (!rail) return;
  const max = rail.scrollWidth - rail.clientWidth;
  rail.classList.toggle('of-left', rail.scrollLeft > 4);
  rail.classList.toggle('of-right', max > 4 && rail.scrollLeft < max - 4);
}

export function initRail() {
  if (!rail) return;
  rail.addEventListener('scroll', update, { passive: true });
  addEventListener('resize', update);
  // chips are rendered by other modules; measure once they are in the DOM
  requestAnimationFrame(update);
}
